import { Injectable } from '@angular/core';

import { ErrorMessageResponse } from '@app/core/models/data-response';
import { GridRow } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class CustProdAccBcsService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 2994
     * @returns the accounting configuration for the current context.
     */
    public async getCustProdAccBcs(): Promise<CustProdAccBcsGet> {
        return (await this.dataTask.Post(2994, {}))[0];
    }

    /**
     * @datatask 2999
     * @param params accounting configuration and the rule being saved.
     * @returns the save validation response.
     */
    public async saveCustProdAccBcs(params: SaveCustProdAccBcsParams): Promise<ErrorMessageResponse> {
        return (await this.dataTask.Post(2999, params))[0];
    }
}

export interface CustProdAccBcsGet {
    businessco_no: string;
    account_no: string;
    account_name: string;
    account_no_free: string;
    account_name_free: string;
    account_no_export: string;
    account_name_export: string;
    account_no_free_export: string;
    account_name_free_export: string;
}

export interface SaveCustProdAccBcsParams extends CustProdAccBcsGet {
    custprodaccbc_keyno: string | number;
}

export interface CustProdAccBcsGridRow extends GridRow {
    custprodaccbc_keyno: string | number;
    is_selected: boolean | '0' | '1';
}
